module.exports = require('./lib/React');



//////////////////
// WEBPACK FOOTER
// /~/react-intl/~/react/react.js
// module id = 1726
// module chunks = 0